let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3XMOA"), load("3VpdY")]).then(() => parcelRequire('iqUA6'));